import axios from 'axios';

/**
 * FormList sayfası için API servis fonksiyonları
 */
class FormListService {
  constructor() {
    this.baseURL = 'https://app.hhoms.com/api';
  }

  /**
   * API isteği için header'ları oluşturur
   */
  getHeaders(appToken, userId) {
    return {
      ApplicationToken: appToken,
      User: userId,
      'Content-Type': 'application/json'
    };
  }

  /**
   * Formları listeler
   */
  async fetchForms(appToken, userId) {
    try {
      const response = await axios.get(
        `${this.baseURL}/form/Libraries/list/0/0`,
        {
          headers: this.getHeaders(appToken, userId)
        }
      );
      return response.data.formLibraries || [];
    } catch (error) {
      console.error('Forms fetch error:', error);
      throw new Error('Formlar yüklenirken bir hata oluştu.');
    }
  }

  /**
   * Form siler
   */
  async deleteForm(formId, appToken, userId) {
    try {
      await axios.delete(
        `${this.baseURL}/form/Libraries/${formId}`,
        {
          headers: this.getHeaders(appToken, userId)
        }
      );
      return true;
    } catch (error) {
      console.error('Form delete error:', error);
      throw new Error('Form silinirken bir hata oluştu');
    }
  }

  /**
   * Form durumunu değiştirir (aktif/pasif)
   */
  async toggleFormStatus(formId, newStatus, appToken, userId) {
    try {
      const response = await axios.put(
        `${this.baseURL}/form/Libraries/statu/${formId}/${newStatus}`,
        null,
        {
          headers: this.getHeaders(appToken, userId)
        }
      );
      return response.status === 200;
    } catch (error) {
      console.error('Form status toggle error:', error);
      throw new Error('Form durumu güncellenirken bir hata oluştu');
    }
  }

  /**
   * Form detaylarını getirir
   */
  async getFormDetails(formId, appToken, userId) {
    try {
      const response = await axios.get(
        `${this.baseURL}/form/Libraries/${formId}`,
        {
          headers: this.getHeaders(appToken, userId)
        }
      );
      
      if (!response.data?.formLibraries?.[0]) {
        throw new Error('Form detayları alınamadı');
      }
      
      return response.data.formLibraries[0];
    } catch (error) {
      console.error('Form details fetch error:', error);
      throw new Error('Form detayları alınamadı');
    }
  }

  /**
   * Yeni form oluşturur (kopyalama için)
   */
  async createForm(formData, appToken, userId) {
    try {
      const response = await axios.post(
        `${this.baseURL}/form/Libraries`,
        formData,
        {
          headers: this.getHeaders(appToken, userId)
        }
      );
      return response.data;
    } catch (error) {
      console.error('Form create error:', error);
      throw new Error('Form oluşturulurken bir hata oluştu');
    }
  }

  /**
   * Formu kopyalar
   */
  async copyForm(originalForm, appToken, userId) {
    try {
      // Form detaylarını al
      const formDetails = await this.getFormDetails(originalForm.formId, appToken, userId);
      
      // Form içeriğini parse et
      let parsedFormContent;
      try {
        parsedFormContent = typeof formDetails.formContent === 'string' 
          ? JSON.parse(formDetails.formContent)
          : formDetails.formContent;
      } catch (error) {
        console.error('Form content parse error:', error);
        parsedFormContent = formDetails.formContent;
      }

      // 6 haneli rastgele formId oluştur
      const newFormId = Math.floor(100000 + Math.random() * 900000).toString();

      // Yeni form içeriği
      const formContent = {
        id: newFormId,
        title: `${formDetails.title} (Kopya)`,
        description: parsedFormContent.description || '',
        fields: parsedFormContent.fields || [],
        settings: parsedFormContent.settings || {},
        isPublished: true,
        publishedAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        formLink: ''
      };

      // Yeni form verisi
      const formData = {
        id: newFormId,
        title: `${formDetails.title} (Kopya)`,
        description: parsedFormContent.description || '',
        formId: newFormId,
        fields: parsedFormContent.fields || [],
        formContent: JSON.stringify(formContent),
        isActive: formDetails.isActive,
        parentId: formDetails.parentId || '0'
      };

      // Yeni formu oluştur
      return await this.createForm(formData, appToken, userId);
    } catch (error) {
      console.error('Form copy error:', error);
      throw new Error(`Form çoğaltılırken bir hata oluştu: ${error.message}`);
    }
  }

  /**
   * Formu arşivler
   */
  async archiveForm(formId, appToken, userId) {
    try {
      await axios.put(
        `${this.baseURL}/form/Libraries/archive/${formId}/true`,
        null,
        {
          headers: this.getHeaders(appToken, userId)
        }
      );
      return true;
    } catch (error) {
      console.error('Form archive error:', error);
      throw new Error('Form arşivlenirken bir hata oluştu');
    }
  }

  /**
   * Public form URL'i oluşturur
   */
  generatePublicFormUrl(formId, baseUrl = window.location.origin) {
    return `${baseUrl}/public-form/${formId}`;
  }

  /**
   * Public spreadsheet URL'i oluşturur
   */
  generatePublicSpreadsheetUrl(formId, baseUrl = window.location.origin) {
    return `${baseUrl}/public-spreadsheet/${formId}`;
  }

  /**
   * Share URL'i oluşturur
   */
  generateShareUrl(formId, baseUrl = window.location.origin) {
    return `${baseUrl}/user-login?formId=${formId}`;
  }
}

export default new FormListService();
